export default "__VITE_ASSET__0a8039e0__"